import { Row, Col, Button } from 'react-bootstrap';
import Section from '../components/Section';
import BenefitCard from '../components/BenefitCard';
import CTASection from '../components/CTASection';
import Seo from '../components/Seo';

const Home = () => {
    return (
        <>
            <Seo
                title="Fractional Sales VP for Industrial B2B Companies | SalesFractionPro"
                description="Fractional Sales VP & Commercial Leadership for Industrial B2B Companies. Driving sales growth, pricing discipline, and end-to-end commercial execution."
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'WebPage',
                    name: 'Fractional Sales VP for Industrial B2B Companies',
                    description: 'Fractional sales leadership and commercial execution support for industrial B2B companies.',
                    about: {
                        '@type': 'Service',
                        name: 'Fractional Sales Leadership',
                    },
                }}
            />

            <Section className="hero" variant="hero">
                <Row className="align-items-center gy-4">
                    <Col>
                        <h1>Fractional Sales VP &amp; Commercial Leadership
                            <br />
                            for Industrial B2B Companies</h1>
                        <p className="lead">
                            Led by Lutfu Okman, a senior global B2B sales and commercial executive with 20+ years of experience
                        </p>
                        <ul className="hero-list">
                            <li>Senior execution when growth, margins, and focus matter most.</li>
                            <li>
                                When your business needs experienced commercial leadership—but not a full-time executive—a Fractional Sales VP gives you immediate access to senior expertise, hands-on execution, and accountability for results, at a fraction of the cost and risk.
                            </li>
                            <li>
                                I work as part of your leadership team to strengthen sales performance, pricing discipline, and commercial execution—helping you move faster, make better decisions, and build a scalable growth engine.
                            </li>
                        </ul>
                        <div className="hero-actions">
                            <Button as="a" href="/contact" variant="primary" size="lg">
                                Send Inquiry
                            </Button>
                        </div>
                    </Col>
                    {/* <Col lg={5}>
                        <div className="hero-panel">
                            <h2>Fractional Sales VP for Industrial B2B Companies</h2>
                            <p>Driving sales growth, pricing discipline, and end-to-end commercial execution</p>
                            <div className="credibility-card">
                                Led by Lutfu Okman, a senior global B2B sales and commercial executive with 20+ years of experience
                            </div>
                        </div>
                    </Col> */}
                </Row>
            </Section>

            <Section variant='alt' className='pb-5 pt-6'>
                <Row className="g-5 align-items-start">
                    <Col lg={6}>
                        <h3>When is a Fractional Sales VP the right fit?</h3>
                        <p className="lead">This model is ideal if:</p>
                        <ul className="checklist">
                            <li>You are a founder-led startup or SMB, and sales still depends heavily on the CEO</li>
                            <li>You are growing, but a full-time Sales or Commercial VP is premature</li>
                            <li>Revenue is flat, inconsistent, or declining, and you need experienced leadership to reset direction</li>
                            <li>You have a strategy, but execution, discipline, or accountability is weak</li>
                            <li>You are facing a sudden leadership gap, transition, or turnaround situation</li>
                            <li>You need to professionalize sales ahead of scale, acquisition, or exit</li>
                        </ul>
                    </Col>
                    <Col lg={6}>
                        <h3>What you get</h3>
                        <p className="lead">As a fractional member of your executive team, I help you:</p>
                        <ul className="checklist">
                            <li>Define or refine your commercial and sales strategy</li>
                            <li>Translate strategy into clear priorities, actions, and timelines</li>
                            <li>Improve pricing, margin discipline, and forecasting accuracy</li>
                            <li>Build structure, process, and accountability in sales</li>
                            <li>Coach leaders and teams to perform at a higher level</li>
                            <li>Deliver measurable commercial results, not just plans</li>
                        </ul>
                    </Col>
                </Row>
            </Section>

            <Section className="py-5">
                <Row className="mb-4">
                    <Col lg={8}>
                        <h2>Why Fractional Commercial Leadership?</h2>
                    </Col>
                </Row>
                <Row className="g-4">
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Lower Cost"
                            description="Senior leadership at approximately 25–35% of the cost of a full-time executive. Pay for impact, not overhead."
                        />
                    </Col>
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Lower Risk"
                            description="No long-term commitment, severance, or organizational disruption."
                        />
                    </Col>
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Fast Impact"
                            description="Immediate engagement—no lengthy search, onboarding, or ramp-up."
                        />
                    </Col>
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Flexible Engagement"
                            description="Scale leadership up or down as business needs change."
                        />
                    </Col>
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Execution, Not Advice"
                            description="I don’t just assess and recommend—I lead, implement, and take accountability."
                        />
                    </Col>
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Objective Perspective"
                            description="Independent, unbiased insight combined with proven, real-world solutions."
                        />
                    </Col>
                    <Col md={6} lg={4}>
                        <BenefitCard
                            title="Crisis and Turnaround Experience"
                            description="Proven ability to lead through complexity, pressure, and change."
                        />
                    </Col>
                </Row>
            </Section>

            <Section variant='alt'>
                <CTASection
                    heading="Ready to strengthen your sales leadership?"
                    primaryLabel="Send Inquiry"
                    primaryTo="/contact"
                >
                    <p className='lead'>Let's discuss your growth challenges and see if fractional sales leadership is the right fit.</p>
                </CTASection>
            </Section>
        </>
    );
};

export default Home;

